import React from 'react';
import { StepProps, SPECIALTY_COLORS } from '../../types';
import { motion } from 'framer-motion';
import { ArrowRight, Droplets, Heart, FlaskConical, Stethoscope, Target, BarChart3, Zap, Map } from 'lucide-react';
export function HookScreen({
  nextStep,
  onOpenStoryboard
}: StepProps & {
  onOpenStoryboard?: () => void;
}) {
  return <div className="flex-grow flex flex-col justify-center items-center px-6 relative overflow-hidden min-h-screen" data-id="element-239">
      <div className="absolute top-[-10%] right-[-5%] w-[60vw] h-[60vw] rounded-full bg-brand/5 blur-3xl -z-10" data-id="element-240" />
      <div className="absolute bottom-[-10%] left-[-5%] w-[40vw] h-[40vw] rounded-full bg-brand/5 blur-3xl -z-10" data-id="element-241" />

      <div className="max-w-4xl mx-auto text-center z-10" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-243">
          <span className="inline-block py-1 px-3 rounded-full bg-gray-100 text-gray-600 text-sm font-semibold tracking-wider uppercase mb-4" data-id="element-244">
            Welcome to the Workshop
          </span>
          <p className="text-xl text-gray-500 font-medium mb-8" data-id="element-245">
            4 groups. 4 specialties. 1 shared challenge.
          </p>
        </motion.div>

        <motion.h1 className="text-4xl md:text-6xl font-bold leading-tight mb-10 text-dark" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-246">
          Are all specialties aligned in how they manage CKD?
        </motion.h1>

        <motion.div className="flex justify-center gap-6 mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} data-id="element-247">
          {[{
          icon: Droplets,
          color: SPECIALTY_COLORS.Nephrologist
        }, {
          icon: Heart,
          color: SPECIALTY_COLORS.Cardiologist
        }, {
          icon: FlaskConical,
          color: SPECIALTY_COLORS.Endocrinologist
        }, {
          icon: Stethoscope,
          color: SPECIALTY_COLORS.PCP
        }].map((item, i) => <div key={i} className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm" style={{
          backgroundColor: `${item.color}15`,
          color: item.color
        }} data-id="element-248">
              <item.icon size={32} data-id="element-249" />
            </div>)}
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-250">
          {[{
          icon: Target,
          label: 'Sharpen segmentation & targeting',
          letter: 'A'
        }, {
          icon: BarChart3,
          label: 'Prioritise features, arguments & data',
          letter: 'B'
        }, {
          icon: Zap,
          label: 'Find the right motivation to present',
          letter: 'C'
        }].map(obj => <div key={obj.letter} className="bg-gray-50 rounded-2xl p-5 border border-gray-100 text-left flex items-start" data-id="element-251">
              <div className="w-8 h-8 rounded-lg bg-brand/10 text-brand flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-252">
                <obj.icon size={18} data-id="element-253" />
              </div>
              <div data-id="element-254">
                <span className="text-xs font-bold text-brand uppercase tracking-wider" data-id="element-255">
                  Objective {obj.letter}
                </span>
                <p className="text-sm font-semibold text-dark mt-0.5" data-id="element-256">
                  {obj.label}
                </p>
              </div>
            </div>)}
        </motion.div>

        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-257">
          <button onClick={nextStep} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white transition-all duration-200 bg-brand rounded-full hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand" data-id="element-258">
            Let's Begin
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-259" />
          </button>
          {onOpenStoryboard && <button onClick={onOpenStoryboard} className="inline-flex items-center justify-center px-6 py-4 text-base font-semibold text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors" data-id="element-260">
              <Map size={18} className="mr-2" data-id="element-261" />
              View Storyboard
            </button>}
        </motion.div>
      </div>
    </div>;
}